export const updateUser = `
mutation($user: UserNew!) {
    user {
        update(user: $user)
    }
}
`

export const findOrderByCode = `
query($code: String!) {
    order {
        findByCode(code: $code) {
            buyerName
            buyerEmail
            buyerAddress
            buyerPhoneNumber
            campaignId
            totalCount
            subtotal
            platformFee
            floorplanLocation {
                x
                y
            }
            stripeFee
            boughtAt
            campaign {
                name
                collectAddress
                hideDisplayTime
                surveyQuestion
                description
                location
                secretLocation
                startTime {
                    year
                    month
                    day
                    hour
                    minute
                    PM
                }
                media {
                    logo
                }
                floorplan {
                    height
                    width
                    inventoryMap {
                        x
                        y
                        inventoryItemId
                        bought
                        buyerName
                        bid {
                            buyerName
                            buyerEmail
                            numBids
                            currentBid
                        }
                    }
                    labels {
                        x
                        y
                        label
                    }
                }
            }
            orderComponents {
                inventoryItemId
                name
                price
                count
                validated
            }
            code
        }
    }
}
`

export const isUsernameAvailable = `
query($username: String!) {
    user {
        isUsernameAvailable(username: $username)
    }
}
`

export const signup = `
mutation($user: UserNew!) {
    user {
        create(user: $user)
    }
}
`

export const isEmailAvailable = `
query($email: String!) {
    user {
        isEmailAvailable(email: $email)
    }
}
`

export const findCampaignsByUserId = `
query($userId: String!) {
    campaign {
        findByUserId(userId: $userId) {
            id
            name
            createdBy
            directSales
            location
            secretLocation
            payoutDate
            hideDisplayTime
            totalEarnings
            collectAddress
            surveyQuestion
            subdomain
            earlyPayout
            standardStripeId
            indirectSales
            revenue
            isActive
            description
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
            timezoneOffset
            media {
                cover
                logo
            }
            totalPlatformFee
            totalStripeFee
        }
    }
}
`;

export const findByIdWithStatsFor = `
query($id: String!, $username: String!) {
    campaign {
        findByIdWithStatsFor(id: $id, username: $username) {
            id
            name
            createdBy
            earlyPayout
            standardStripeId
            createdByUsername
            isActive
            disputeAmount
            directSales
            location
            secretLocation
            totalEarnings
            indirectSales
            collectAddress
            hideDisplayTime
            deletedAt
            surveyQuestion
            payoutDate
            linkPageViews
            revenue
            maxLevels
            showLeaderboard
            description
            checkedIn
            subdomain
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
            timezoneOffset
            fee {
                perItemFee
                perOrderFee
                maxItemsPerOrder
            }
            media {
                cover
                logo
            }
            totalPlatformFee
            totalStripeFee
            floorplan {
                height
                width
                inventoryMap {
                    x
                    y
                    inventoryItemId
                    bought
                    buyerName
                    bid {
                        buyerName
                        buyerEmail
                        numBids
                        currentBid
                    }
                }
                labels {
                    x
                    y
                    label
                }
            }
        }
    }
}
`;

export const findCampaignById = `
query($id: String!) {
    campaign {
        findById(id: $id) {
            id
            name
            createdBy
            createdByUsername
            isActive
            disputeAmount
            earlyPayout
            standardStripeId
            directSales
            totalEarnings
            indirectSales
            collectAddress
            hideDisplayTime
            secretLocation
            location
            deletedAt
            surveyQuestion
            payoutDate
            linkPageViews
            revenue
            maxLevels
            showLeaderboard
            description
            checkedIn
            subdomain
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
            timezoneOffset
            fee {
                perItemFee
                perOrderFee
                maxItemsPerOrder
            }
            media {
                cover
                logo
            }
            totalPlatformFee
            totalStripeFee
            floorplan {
                height
                width
                inventoryMap {
                    x
                    y
                    inventoryItemId
                    bought
                    buyerName
                    bid {
                        buyerName
                        buyerEmail
                        numBids
                        currentBid
                    }
                }
                labels {
                    x
                    y
                    label
                }
            }
        }
    }
}
`;

export const findCampaignBySubdomain = `
query($subdomain: String!) {
    campaign {
        findBySubdomain(subdomain: $subdomain) {
            id
            name
            createdBy
            isActive
            directSales
            collectAddress
            standardStripeId
            earlyPayout
            surveyQuestion
            location
            secretLocation
            totalEarnings
            indirectSales
            hideDisplayTime
            revenue
            description
            subdomain
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
            timezoneOffset
            fee {
                perItemFee
                perOrderFee
                maxItemsPerOrder
            }
            media {
                cover
                logo
            }
            floorplan {
                height
                width
                inventoryMap {
                    x
                    y
                    inventoryItemId
                    bought
                    buyerName
                    bid {
                        buyerName
                        buyerEmail
                        numBids
                        currentBid
                    }
                }
                labels {
                    x
                    y
                    label
                }
            }
        }
    }
}
`;

export const createCampaign = `
mutation($campaign: CampaignNewObject!) {
    campaign {
        create(campaign: $campaign) {
            id
        }
    }
}
`;

export const updateCampaign = `
mutation($campaign: CampaignNewObject!, $campaignId: String!) {
    campaign {
        update(campaign: $campaign, campaignId: $campaignId)
    }
}
`;

export const getInventoryItems = `
query($campaignId: String!, $sellerId: String!) {
    inventoryItem {
        getInventory(campaignId: $campaignId, sellerId: $sellerId) {
            id
            name
            description
            bought
            sellAfter
            validated
            price
            quantity
            sell
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
            autoSale
            available
            allocatedBy
            commission
            sharedBy {
                commission
                username
                quantity
                maxQuantity
                minQuantity
                maxCommission
            }
        }
    }
}
`;

export const getInventoryItemsAsString = `
query($campaignId: String!, $sellerId: String!) {
    inventoryItem {
        getInventoryAsString(campaignId: $campaignId, sellerId: $sellerId)
    }
}
`;

export const getInventoryAsStringForCheckout = `
query($campaignId: String!, $sellerId: String!) {
    inventoryItem {
        getInventoryAsStringForCheckout(campaignId: $campaignId, sellerId: $sellerId)
    }
}
`;

export const updateSellInventoryItem = `
mutation($inventoryItemId: String!, $newSell: Boolean!, $sellerId: String!, $campaignId: String!) {
    inventoryItem {
        updateSell(inventoryItemId: $inventoryItemId, newSell: $newSell, sellerId: $sellerId, campaignId: $campaignId)
    }
}
`

export const getLeaderboard = `
query($campaignId: String!, $createdBy: String!) {
    order {
        getLeaderboardItems(campaignId: $campaignId, createdBy: $createdBy) {
            sellerId
            name
            sold
            isHost
            addedBy
            isPaymentSetup
        }
    }
}
`

export const getOrders = `
query($campaignId: String!, $username: String!) {
    order {
        getByCampaignId(campaignId: $campaignId, username: $username) {
            buyerName
            buyerEmail
            status
            totalCount
            revenue
            code
            sellerName
            boughtAt
            directSale
        }
    }
}
`;

export const isUserHost = `
query($campaignId: String!, $userId: String!) {
    cohost {
        isHost(campaignId: $campaignId, userId: $userId) 
    }
}
`

export const createInventoryItem = `
mutation($inventoryItem: InventoryItemNewObject!, $sellerId: String!, $bid: Boolean!) {
    inventoryItem {
        create(inventoryItem: $inventoryItem, sellerId: $sellerId, bid: $bid)
    }
}
`;

export const updateInventoryItem = `
mutation($inventoryItem: InventoryItemNewObject!, $sellerId: String!, $inventoryItemId: String!, $bid: Boolean!) {
    inventoryItem {
        update(inventoryItem: $inventoryItem, sellerId: $sellerId, inventoryItemId: $inventoryItemId,  bid: $bid)
    }
}
`;

export const shareInventoryItems = `
mutation($inventoryItems: [InventoryItemPassOn!]!, $userId: String!, $campaignId: String!, $usernamesAndEmailsArray: [String!]!) {
    inventoryItem {
        shareInventory(inventoryItems: $inventoryItems, userId: $userId, campaignId: $campaignId, usernamesAndEmailsArray: $usernamesAndEmailsArray)
    }
}
`

export const updateSharedInventorybyAffiliate = `
mutation($inventoryItems: [InventoryItemUpdateByUsername!]!, $userId: String!, $campaignId: String!, $username: String!) {
    inventoryItem {
        updateSharedInventorybyAffiliate(inventoryItems: $inventoryItems, userId: $userId, campaignId: $campaignId, username: $username)
    }
}
`

export const updateSharedInventorybyInventoryId = `
mutation($inventoryItems: [InventoryItemUpdateByInventoryId!]!, $userId: String!, $campaignId: String!, $inventoryItemId: String!) {
    inventoryItem {
        updateSharedInventorybyInventoryId(inventoryItems: $inventoryItems, userId: $userId, campaignId: $campaignId, inventoryItemId: $inventoryItemId)
    }
}
`

export const findUserByUsername = `
query($username: String!) {
    user {
        findByUsername(username: $username) {
            id
            name
            lastname
            username
            email
            avatar
        }
    }
}
`

export const purchase = `
mutation($name: String!, $email: String!, $phoneNumber: String!, $address: String, $campaignId: String!, $code: String!, $orderComponents: [OrderComponentInput!]!, $sellerId: String!, $floorplanLocationX: String, $floorplanLocationY: String, $sessionId: String!) {
    order {
        purchase(name: $name, email: $email, phoneNumber: $phoneNumber, address: $address, campaignId: $campaignId, code: $code, orderComponents: $orderComponents, sellerId: $sellerId, floorplanLocationX: $floorplanLocationX, floorplanLocationY: $floorplanLocationY, sessionId: $sessionId) 
    }
}
`

export const prePurchase = `
mutation($name: String!, $email: String!, $phoneNumber: String!, $address: String, $campaignId: String!, $orderComponents: [OrderComponentInput!]!, $sellerId: String!, $floorplanLocationX: String, $floorplanLocationY: String) {
    order {
        prePurchase(name: $name, email: $email, phoneNumber: $phoneNumber, address: $address, campaignId: $campaignId, orderComponents: $orderComponents, sellerId: $sellerId, floorplanLocationX: $floorplanLocationX, floorplanLocationY: $floorplanLocationY) 
    }
}
`

export const bid = `
mutation($name: String!, $email: String!, $phoneNumber: String!, $address: String, $campaignId: String!, $sessionId: String!, $sellerId: String!, $floorplanLocationX: String, $floorplanLocationY: String, $bidId: String!, $bid: String!) {
    order {
        bid(name: $name, email: $email, phoneNumber: $phoneNumber, address: $address, campaignId: $campaignId, sessionId: $sessionId, sellerId: $sellerId, floorplanLocationX: $floorplanLocationX, floorplanLocationY: $floorplanLocationY, bid: $bid, bidId: $bidId) 
    }
}
`

export const preBid = `
mutation($name: String!, $email: String!, $phoneNumber: String!, $address: String, $campaignId: String!, $sellerId: String!, $floorplanLocationX: String, $floorplanLocationY: String, $bidId: String!, $bid: String!) {
    order {
        preBid(name: $name, email: $email, phoneNumber: $phoneNumber, address: $address, campaignId: $campaignId, sellerId: $sellerId, floorplanLocationX: $floorplanLocationX, floorplanLocationY: $floorplanLocationY, bid: $bid, bidId: $bidId) 
    }
}
`

export const findInventoryById = `
query($id: String!) {
    inventoryItem {
        findById(id: $id) {
            startTime {
                year
                month
                day
                hour
                minute
                PM
            }
            endTime {
                year
                month
                day
                hour
                minute
                PM
            }
        }
    }
}
`

export const setup = `
query($userId: String!) {
    user {
        isSetupIncomplete(userId: $userId) {
            email
            username
            name
            lastname
            lastLoginAt
        }
    }
}
`

export const isSubdomainAvailable = `
query($subdomain: String!) {
    campaign {
        isSubdomainAvailable(subdomain: $subdomain)
    }
}
`

export const deleteInventory = `
mutation($id: String!, $campaignId: String!) {
    inventoryItem {
        delete(id: $id, campaignId: $campaignId)
    }
}
`

export const deleteCampaign = `
mutation($id: String!) {
    campaign {
        delete(id: $id)
    }
}
`

export const isPaymentSetup = `
query($id: String!) {
    user {
        isPaymentSetup(id: $id)
    }
}
`

export const checkInOneTicket = `
    mutation($code: String!, $inventoryItemId: String!) {
        order {
            checkInOneOrderComponent(code: $code, inventoryItemId: $inventoryItemId)
        }
    }
`

export const checkInAllTickets = `
    mutation($code: String!) {
        order {
            checkInAllOrderComponents(code: $code)
        }
    }
`

export const payoutCampaign = `
mutation($campaignId: String!) {
    campaign {
        payout(campaignId: $campaignId)
    }
}
`

export const incPageViews = `
mutation($subdomain: String!, $username: String) {
    campaign {
        incrementLinkPageViews(subdomain: $subdomain, username: $username)
    }
}
`

export const resendOrderEmail = `
mutation($email: String!, $code: String!) {
    order {
        resendOrderEmail(email: $email, code: $code)
    }
}
`

export const refundOrder = `
mutation($code: String!) {
    order {
        refund(code: $code)
    }
}
`

export const emailBlast = `
mutation($campaignId: String!, $emailType: String!, $sendTo: String!, $customEmails: [String!], $message: [String!], $shareVia: String!) {
    campaign {
        emailBlast(campaignId: $campaignId, emailType: $emailType, sendTo: $sendTo, customEmails: $customEmails, message: $message, shareVia: $shareVia)
    }    
}
`
export const updateCohost = `
mutation($campaignId: String!, $userId: String!, $isHost: Boolean!) {
    cohost {
        updateCohost(campaignId: $campaignId, userId: $userId, isHost: $isHost)
    }
}
`
export const setUpStripeStandard = `
mutation($email: String!) {
    user {
        setUpStripeStandard(email: $email)
    }
}
`


// WEBPACK FOOTER //
// ./src/components/graphql/queries.tsx